// React
import React from 'react';
import { Helmet } from 'react-helmet-async';

// Types
type HTMLHeadComponentProps = {
    description: string;
    title: string;
    version: string;
};

/**
 * For special head and meta data
 * @see https://create-react-app.dev/docs/title-and-meta-tags/
 *
 * with bugfix for normal HELMET https://github.com/nfl/react-helmet/issues/548
 * @see https://www.npmjs.com/package/react-helmet-async
 *
 * @param props HTMLHeadComponentProps
 * @returns React.ReactElement
 */
export default function HTMLHeadComponent(props: HTMLHeadComponentProps): React.ReactElement {
    return (
        <Helmet>
            <title>
                {props.title}@{props.version}
            </title>
            <meta name="description" content={props.description} />
        </Helmet>
    );
}
